import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { getOptionsObject } from '../../utils/api';
import {
  FETCH_YODLEE_CONSENT,
  YODLEE_REFRESH,
  fetchYodleeConsentSuccess,
  fetchYodleeConsentError,
  yodleeRefreshSuccess,
  yodleeRefreshError,
} from './actions';

export const fetchYodleeConsent: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_YODLEE_CONSENT),
    flatMap(() =>
      ajax(getOptionsObject('/rps/participant-profile/consent?consentType=47'))
        .pipe(map((res: any) => fetchYodleeConsentSuccess(res.response)))
        .pipe(catchError(ex => of(fetchYodleeConsentError(ex)))),
    ),
  );

export const refreshYodlee: Epic = action$ =>
  action$.pipe(
    ofType(YODLEE_REFRESH),
    flatMap(() =>
      ajax(getOptionsObject('/rps/workplace/ui/accounts?forceRefresh=true'))
        .pipe(map((res: any) => yodleeRefreshSuccess(res.response)))
        .pipe(catchError(ex => of(yodleeRefreshError(ex)))),
    ),
  );
